import { render } from "./Breadcrumbs.vue?vue&type=template&id=22014212&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=22014212&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22014212"]])

export default __exports__